import { LAST_TASK_TOKEN_NAME } from '../constants';

const storage = localStorage || window.localStorage;

export const setLastTask = lastTask => storage && storage.setItem(LAST_TASK_TOKEN_NAME, lastTask);

export const getLastTask = () => storage && storage.getItem(LAST_TASK_TOKEN_NAME);

export const removeLastTask = () => storage && storage.removeItem(LAST_TASK_TOKEN_NAME);
